import React from 'react';
import styled from '@emotion/styled';
import backgroundImage from '../assets/Background.jpg';

const HeroSection = styled.div`
  height: 40vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  color: white;
`;

const HeroTitle = styled.h1`
  font-family: 'century gothic';
  font-size: 4rem;
  text-align: center;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const AboutContainer = styled.div`
  padding: 120px 2rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 120px 4rem 4rem;
  }
`;

const Content = styled.div`
  font-family: 'calibri';
  font-size: 1.2rem;
  line-height: 1.6;
  color: #666;
`;

const About = () => {
  return (
    <>
      <HeroSection>
        <HeroTitle>About Us</HeroTitle>
      </HeroSection>
      <AboutContainer>
        <Content>
          <p>
          PDG is a highly successful and experienced commercial real estate development company with over 50 years of combined experience of leadership. We place strong emphasis on collaboration and leveraging the diverse experience of our teams to exceed expectations when developing hotels, healthcare facilities, apartment communities and mixed-use properties for our partners and investors.
          </p>
          <p style={{ marginTop: '1rem' }}>
          Our process is designed to ensure that everyone's areas of expertise are integrated seamlessly, and have a focus on mitigating risk, and executing to the highest standards of quality and efficiency. We take a thorough and comprehensive approach to development. By considering every detail and working together as a team, we're setting ourselves up for success in delivering top-notch results for our partners and investors.
          </p>
        </Content>
      </AboutContainer>
    </>
  );
};

export default About;